__turbopack_context__.v({
  "Price": "SupporterModal-module__-HTDoW__Price",
  "bgCircle": "SupporterModal-module__-HTDoW__bgCircle",
  "bgLight": "SupporterModal-module__-HTDoW__bgLight",
  "bgPrimary": "SupporterModal-module__-HTDoW__bgPrimary",
  "borderStyle": "SupporterModal-module__-HTDoW__borderStyle",
  "card": "SupporterModal-module__-HTDoW__card",
  "closeIcon": "SupporterModal-module__-HTDoW__closeIcon",
  "communityBadge": "SupporterModal-module__-HTDoW__communityBadge",
  "overlay": "SupporterModal-module__-HTDoW__overlay",
  "titleText": "SupporterModal-module__-HTDoW__titleText",
  "toggleBtn": "SupporterModal-module__-HTDoW__toggleBtn",
  "toggleBtnGroup": "SupporterModal-module__-HTDoW__toggleBtnGroup",
});
